// modules/ButtonDiv.js
import React        from 'react';

class PlanMapArea extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false};

		this.showHoverAreas = this.showHoverAreas.bind(this);
		this.hideHoverAreas = this.hideHoverAreas.bind(this);
	}

	showHoverAreas() {
		this.props.messenger.publish("s_"+this.props.id, {});
		this.props.messenger.publish("a_"+this.props.id, {});
	}

	hideHoverAreas() {
		this.props.messenger.publish("c_"+this.props.id, {});
	}

	render() {
		return (
			<area shape="poly" href={this.props.data.link} coords={this.props.data.coords} onMouseEnter={this.showHoverAreas} onMouseLeave={this.hideHoverAreas}/>
		);

	}
}

export default PlanMapArea;


/** WEBPACK FOOTER **
 ** ./src/modules/land-for-sale/elements/PlanMapArea.js
 **/